module.exports = __webpack_public_path__ + "img/icons BFr_16.d51f85d4.svg";